import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backIcon from "./images/backk.png";
import switchIcon from "./images/switchh.png";

function StartUps() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [usingBackCamera, setUsingBackCamera] = useState(false);
  const [result, setResult] = useState("");
  const imageCounter = useRef(1);
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem("userEmail");

  const formatDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const currentDateTime = formatDateTime(new Date());

  const handleBackClick = () => navigate(-1);

  const getMediaStream = async () => {
    const videoConstraints = {
      facingMode: usingBackCamera ? "environment" : "user",
    };

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: videoConstraints,
      });
      if (videoRef.current) videoRef.current.srcObject = stream;
    } catch (err) {
      console.error("Error accessing the camera: ", err);
    }
  };

  const insertEmail = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/insert_user_email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userEmail }),
        credentials: "include",
      });
      const data = await response.json();
      if (!data.success) console.error("Failed to insert email:", data.message);
    } catch (err) {
      console.error("Error inserting email:", err);
    }
  };

  const captureFrame = async () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const video = videoRef.current;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const frameData = canvas.toDataURL("image/png").split(",")[1];
    const imageName = `test${imageCounter.current}.png`;
    imageCounter.current += 1;

    const checkinTime = currentDateTime;

    try {
      const response = await fetch("https://www.d-rosa.ai/capture_imagetest", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          image_name: imageName,
          image_data: frameData,
          userEmail,
          checkin_time: checkinTime,
        }),
        credentials: "include",
      });

      const data = await response.json();

      if (data.message === "True") {
        if (data.status === "ignored") {
          setResult("Ignored due to 5 minute rule");
        } else {
          setResult(`True: ${data.matches[0].file}`);
        }
      } else if (data.message === "False") {
        setResult("False");
        setTimeout(() => startImageLoop(), 2000);
      } else {
        setResult(data.message);
      }

      setTimeout(() => startImageLoop(), 2000);
    } catch (err) {
      console.error("Error sending frame to backend:", err);
      setResult("Failed to load image");
    }
  };

  const startImageLoop = async () => {
    captureFrame();
  };

  useEffect(() => {
    if (userEmail) {
      insertEmail();
      getMediaStream();
      startImageLoop();
    } else {
      navigate("/signin");
    }

    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, [usingBackCamera]);

  const handleSwitchCamera = () => {
    setUsingBackCamera((prevState) => !prevState);
  };

  if (!userEmail) {
    navigate("/signin");
    return null;
  }

  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #fff7ad, #ffa9f9)",
        minHeight: "100vh",
        padding: "20px",
        color: "#E11584",
        textAlign: "center",
      }}
    >
      <h1 style={{ color: "#E11584" }}>StartUp Screen</h1>
      <h2>Welcome, {userEmail}</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <video ref={videoRef} width="640" height="480" autoPlay />
        <canvas ref={canvasRef} width="640" height="480" style={{ display: "none" }}></canvas>
      </div>
      <button
        type="button"
        onClick={handleSwitchCamera}
        style={{
          backgroundColor: "#E11584",
          border: "none",
          cursor: "pointer",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <img src={switchIcon} width="30" height="30" alt="Switch Camera" />
      </button>
      <br />
      <br />
      <br />
      <button onClick={handleBackClick}>
        <img src={backIcon} width="30" height="30" alt="Back" />
      </button>
      <br />
      <p>{result}</p>
    </div>
  );
}

export default StartUps;
